import { parseResponse } from "../../utils/parseResponse";
import { OpenClubListing, OpenClubListingsModel } from "../../types";
import { openClubListingsKeys } from "../responseKeys/responseKeys";

export function parseOpenClubListingsResponse(
  openClubListings: string[] | undefined
): OpenClubListingsModel {
  return {
    openClubListings: openClubListings?.map((listing) =>
      parseResponse<OpenClubListing>(
        listing,
        openClubListingsKeys.openClubListings,
        ["ListingId", "ClubId"]
      )
    ),
  };
}
